import { Card, Table, ProgressBar } from "react-bootstrap";
import React, { useEffect } from "react";

function TopFiveTable({ title, data = [{ station: "--", value: 0.0 }, { station: "--", value: 0.0 }, { station: "--", value: 0.0 }, { station: "--", value: 0.0 }, { station: "--", value: 0.0 }], keyName, units }) {
    function precise(x, precision) {
        // @ts-ignore
        return Number.parseFloat(x).toFixed(precision);
        //return Number.parseFloat(x).toPrecision(4);
    }

    useEffect(() => {
        console.log(data)
    },[])

    return (
        <>
            <Card.Title className="fw-bold px-2 pt-1 mb-0 fs-3 text-center dash-title">
                {title}
                {console.log(data[0])}
            </Card.Title>

            <Card.Body className="fs-4 py-1 mx-6 mb-5">

                <Table responsive striped borderless size="sm" className="top-five-table" style={{minWidth: 0}}>
                    <thead>
                        <tr>
                            <th scope="col">Building</th>
                            <th scope="col">Meter</th>
                            <th scope="col">KPI</th>
                        </tr>
                    </thead>

                    <tbody className="text-nowrap">
                        <tr>
                            <td className="col-2">{data[0].building}</td>
                            <td className="col-3">{data[0].station}</td>
                            <td className="col-7"><ProgressBar style={{ color: '#EB33FF' }} now={data[0].value} label={`${precise(data[0].value, 1) + units}`}></ProgressBar></td>

                        </tr>
                        <tr>
                            <td>{data[1].building}</td>
                            <td>{data[1].station}</td>
                            <td><ProgressBar now={data[1].value} label={`${precise(data[1].value, 1) + units}`}></ProgressBar></td>

                        </tr>
                        <tr>
                            <td>{data[2].building}</td>
                            <td>{data[2].station}</td>
                            <td><ProgressBar now={data[2].value} label={`${precise(data[2].value, 1) + units}`}></ProgressBar></td>

                        </tr>
                        <tr>
                            <td>{data[3].building}</td>
                            <td>{data[3].station}</td>
                            <td><ProgressBar now={data[3].value} label={`${precise(data[3].value, 1) + units}`}></ProgressBar></td>

                        </tr>
                        <tr>
                            <td>{data[4].building}</td>
                            <td>{data[4].station}</td>
                            <td><ProgressBar now={data[4].value} label={`${precise(data[4].value, 1) + units}`}></ProgressBar></td>

                        </tr>

                    </tbody>
                </Table>
            
            </Card.Body>
        </>


    );
}


// @ts-ignore
export default TopFiveTable;
